module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Opret fraværsindberetning")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg ansat *")]), _vm._v(" "), _c('DSelect', {
    ref: "userSelect",
    attrs: {
      "items": _vm.filteredUsers,
      "multiple": false,
      "placeholder": 'Vælg ansat',
      "itemsSelected": _vm.itemsSelectedForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectUser,
      "remove": function($event) {
        return _vm.onSelectUser(null)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Ansættelse *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentId),
      expression: "employmentId"
    }],
    staticClass: "height-34 do-select width-100",
    attrs: {
      "disabled": !_vm.userId || !_vm.hasEmploymentsWithNumber
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.employments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n            " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number) + "\n          ")])
  }), 0), _vm._v(" "), (_vm.userId && !_vm.hasEmploymentsWithNumber) ? _c('p', {
    staticClass: "text-explainer marg-05-top"
  }, [_vm._v("\n          Den valgte bruger har ingen ansættelser med tjenestenummer\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Fraværstype *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.absenceType),
      expression: "absenceType"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.absenceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.absenceTypes), function(type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n            " + _vm._s(type.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.startDate,
      "width100": true
    },
    on: {
      "changed": function($event) {
        return _vm.setStartDate($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Slutdato")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.endDate,
      "width100": true
    },
    on: {
      "changed": function($event) {
        return _vm.setEndDate($event)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
    staticClass: "text-explainer",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'right',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312
      }),
      expression: "{\n                  arrow: true,\n                    placement : 'right',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting,
      'do-bttn--submit--disabled': !_vm.isValid
    },
    attrs: {
      "disabled": !_vm.isValid || _vm.isSubmitting,
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          Send til OPUS\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-248faf67!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/CreateOpusAbsence.vue
// module id = 1808
// module chunks = 1